import { settingsForProvider } from 'components/lib/AccountLinkingWindowSettings';
import RemindAPI from 'lib/RemindAPI';
import UNLINK_MUTATION from 'settings/queries/linkedAccountsSettingsContainerUnlinkAccount.gql';
import openPopup from 'utils/openPopup';
import wait from 'utils/wait';

function link(source: any, callback: Function) {
  if (!source.linkedAccountInfo || !source.linkedAccountInfo.authUrl) {
    console.debug(source);
    console.error('cannot link unlinkable account');
    return;
  }

  const popup = openPopup(
    `${source.linkedAccountInfo.authUrl}`,
    `Link with ${source.title}`,
    settingsForProvider(source.providerKey)
  );

  wait(() => popup?.closed).then(
    () => callback(),
    e => {
      console.debug(e, e && e.stack);
      console.error('Error while waiting for account linking popup to close');
      // Reload content sources anyway - hope for the best
      callback();
    }
  );
}

export async function reLink(source: any, callback: Function) {
  const data: any = await RemindAPI.execute({
    mutation: UNLINK_MUTATION,
    variables: { provider: source.providerKey },
  });

  if (data?.unlinkAccount?.error?.message) {
    return callback();
  }

  return link(source, callback);
}
